import { ClientFormData } from "src/types";

export const tableHeaders = ["Logo", "Name", "Time Zone"];

export const MANAGER_CLIENTS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/clients", name: "Clients" },
];

export const DEFAULT_PAGE_SIZE = 10;
export const INITIAL_LAST_PAGE = 1000000000;

export const emptyDraft: ClientFormData = {
  customerId: "",
  companyName: "",
  status: "active",
  primaryContactName: "",
  emailPrimary: "",
  phonePrimary: "",
  accountManager: "",
  customerPortalAccess: false,
  portalLoginEmail: "",
  billingAddressLine1: "",
  billingAddressLine2: "",
  city: "",
  stateProvince: "",
  postcode: "",
  country: "",
  paymentTerms: "",
  contractType: "",
  slaTier: "",
  currency: "",
  taxId: "",
  emailBilling: "",
  customerType: "",
  industry: "",
  tradingName: "",
  contactTitle: "",
  phoneMobile: "",
  notes: "",
  name: "",
};
